import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import Drawer from '@material-ui/core/Drawer';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import { setSidebarVisibility } from '../reducers/ui';

import Responsive from './Responsive';
import Configs from '../config/config';

const env = process.env.NODE_ENV;

export const DRAWER_WIDTH = 240;
export const CLOSED_DRAWER_WIDTH = 55;

const styles = theme => ({
    drawerPaper: {
        position: 'relative',
        // height: 200,
        display: 'flex',
        flexDirection: 'column',
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        backgroundColor: '#262f3d',
        color: 'white',
        borderRight: 'none',
        marginTop: '48px',
        [theme.breakpoints.only('xs')]: {
            marginTop: 0,
            height: '100vh',
            position: 'inherit',
            //backgroundColor: theme.palette.background.default,
            backgroundColor: '#262f3d',
        },
        [theme.breakpoints.up('md')]: {
            border: 'none',
            marginTop: '48px',
        },
    },
    version: {
        marginTop: 'auto',
        padding: '12px',
        textAlign: 'center',
        color: 'rgba(255, 255, 255, 0.5)',
        whiteSpace: 'nowrap',
    },
});

// We shouldn't need PureComponent here as it's connected
// but for some reason it keeps rendering even though mapStateToProps returns the same object
class Sidebar extends PureComponent {
    handleClose = () => this.props.setSidebarVisibility(false);

    toggleSidebar = () => this.props.setSidebarVisibility(!this.props.open);

    render() {
        const {
            children,
            classes,
            closedSize,
            open,
            setSidebarVisibility,
            size,
            width,
            ...rest
        } = this.props;

        const version = (
            <Typography variant='caption' className={classes.version}>
                v{Configs[env].VERSION}
            </Typography>
        );

        return (
            <Responsive
                xsmall={
                    <Drawer
                        variant='temporary'
                        open={open}
                        PaperProps={{
                            className: classes.drawerPaper,
                            style: { width: size 
                            , height : '100%'},
                        }}
                        onClose={this.toggleSidebar}
                        {...rest}
                    >
                        {children}
                        {version}
                    </Drawer>
                }
                small={
                    <Drawer
                        variant='permanent'
                        open={open}
                        PaperProps={{
                            className: classes.drawerPaper,
                            style: {
                                width: open ? size : closedSize,
                                height : 'calc(100% - 48px)'
                            },
                        }}
                        onClose={this.toggleSidebar}
                        {...rest}
                    >
                        {React.cloneElement(children, {
                            dense: true,
                        })}
                        {open && version}
                    </Drawer>
                }
                medium={
                    <Drawer
                        variant='permanent'
                        open={open}
                        PaperProps={{
                            className: classes.drawerPaper,
                            style: {
                                width: open ? size : closedSize,
                                height : 'calc(100% - 48px)'
                            },
                        }}
                        onClose={this.toggleSidebar}
                        {...rest}
                    >
                        {React.cloneElement(children, { dense: true })}
                        {open && version}
                    </Drawer>
                }
            />
        );
    }
}

Sidebar.propTypes = {
    children: PropTypes.node,
    classes: PropTypes.object,
    closedSize: PropTypes.number,
    open: PropTypes.bool.isRequired,
    setSidebarVisibility: PropTypes.func.isRequired,
    size: PropTypes.number,
    width: PropTypes.string,
};

Sidebar.defaultProps = {
    size: DRAWER_WIDTH,
    closedSize: CLOSED_DRAWER_WIDTH,
};

const mapStateToProps = state => ({
    open: state.ui.sidebarOpen,
});

export default compose(
    connect(
        mapStateToProps,
        { setSidebarVisibility }
    ),
    withStyles(styles),
    withWidth({ resizeInterval: Infinity }) // used to initialize the visibility on first render
)(Sidebar);